import api from "@/lib/axiosConfig";
import { baseRoute } from "./artwork";
import { z, ZodType } from "zod";

export const artworkSchema = z.object({
  id: z.string().optional(),

  oeuvresDescriptionNumeroEnregistrement: z
    .string()
    .nonempty("form.error.emptyField"),
});

export const appendNoDuplicateRecordingNumbersRefine = <
  T extends {
    id?: string;
    oeuvresDescriptionNumeroEnregistrement: string;
  },
>(
  schema: ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateRecordingNumbers(
        val.oeuvresDescriptionNumeroEnregistrement,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: "form.error.artwork.duplicateRecordNumbers",
      path: ["oeuvresDescriptionNumeroEnregistrement"],
    },
  );
export async function validateNoDuplicateRecordingNumbers(
  recordingNumber: string,
  id?: string,
) {
  await api.get<void>(
    `${baseRoute}${id ? `/${id}` : ""}/registration-number/validate/no-duplicates`,
    {
      params: {
        value: recordingNumber,
      },
    },
  );
}
